module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.$t('VR_function_list')))]), _vm._v(" "), _c('div', {
    staticClass: "my-5 list-box"
  }, [(this.$store.state.auth.userRole === 'Teacher') ? _c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('vocabulary')
      }
    }
  }, [(_vm.locale === 'tw') ? _c('p', [_vm._v("自訂單字任務")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Create vocabulary mission")])]) : _vm._e(), _vm._v(" "), (this.$store.state.auth.userRole === 'Teacher') ? _c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('conversation', 0)
      }
    }
  }, [(_vm.locale === 'tw') ? _c('p', [_vm._v("自訂對話任務")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Create conversation mission")])]) : _vm._e(), _vm._v(" "), (this.$store.state.auth.userRole === 'Teacher') ? _c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('Classroom_record')
      }
    }
  }, [(_vm.locale === 'tw') ? _c('p', [_vm._v("觀看使用紀錄")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Using record")])]) : _vm._e(), _vm._v(" "), (this.$store.state.auth.userRole === 'Teacher') ? _c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('VR_classroom')
      }
    }
  }, [(_vm.locale === 'tw') ? _c('p', [_vm._v("開始上課")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Start a new course")])]) : _vm._e(), _vm._v(" "), (this.$store.state.auth.userRole === 'Teacher') ? _c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('VR_resource')
      }
    }
  }, [(_vm.locale === 'tw') ? _c('p', [_vm._v("教用資源")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Learning Resources")])]) : _vm._e(), _vm._v(" "), (this.$store.state.auth.userRole === 'Teacher') ? _c('div', {
    staticClass: "menu-box",
    on: {
      "click": _vm.createSerialCode
    }
  }, [(_vm.locale === 'tw') ? _c('p', [_vm._v("產生登入序號")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Create serial number")])]) : _vm._e(), _vm._v(" "), (this.$store.state.auth.userRole === 'Student') ? _c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('VR_record', _vm.$store.state.auth.user.id)
      }
    }
  }, [(_vm.locale == 'tw') ? _c('p', [_vm._v("觀看使用紀錄")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Using record")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e882eb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/VRIndex.vue
// module id = 776
// module chunks = 3